import DOMReady from '../utils/DOMReady'
import Accordion from '../modules/accordion'

// eslint-disable-next-line no-unused-vars
import css from '../../css/blocks/faq.scss'

class Faq {
  constructor(el) {
    this.container = el
    this.accordions = this.container.querySelectorAll('.accordion')
    this.init()
  }

  init() {
    if (this.accordions.length) {
      Array.from(this.accordions).map(accordion => new Accordion(accordion))
    }
  }
}

DOMReady(() => {
  const elements = document.querySelectorAll('.faq')
  if (elements !== null) {
    elements.forEach(element => new Faq(element))
  }
})
